const axios = require('axios')
const querystring = require('querystring')

class consentApi {
  constructor (config) {
    this.updateConfig(config)
  }

  updateConfig (_config) {
    const config = Object.assign({}, this.config, _config)
    const { client, version, root, domain, app_domain, user_locale, authToken } = config

    if (client) {
      this.client = client
    } else {
      const headers = {
        'Content-Type': 'application/json',
      }
      if (authToken) { headers.Authorization = `Bearer ${authToken}` }

      this.client = axios.create({
        baseURL: `${root}/v${version}/consent`,
        headers: headers,
      })
      this.client.interceptors.response.use(undefined, this._retryFailedRequest)
    }

    this.config = config
    this.baseParams = { domain, user_locale, app_domain }
  }

  _retryFailedRequest (err) {
    const retryCode = [502, 503, 504].indexOf(err.status) !== -1
    if (retryCode && err.config && !err.config.__isRetryRequest) {
      err.config.__isRetryRequest = true
      return axios(err.config)
    }
    throw err
  }

  _stringify (params) {
    return params ? `?${querystring.stringify(params)}` : ''
  }

  getConsentStatus (params) {
    return this.client.get(`/status${this._stringify(Object.assign({}, this.baseParams, params))}`)
  }

  getConsentMatrix (isoCode) {
    return this.client.get(`/matrix/${isoCode}`)
  }

}

module.exports = consentApi



// WEBPACK FOOTER //
// ./shared/consents/api.js